import React from 'react'
import { format_date } from '../smart_bps/lib/utils'

const AccessObjectTooltip = ({ data, position }) => {
  if (!data) {
    return null
  }

  return (
    <div
      className="access-object-tooltip"
      style={{
        position: 'fixed',
        top: position?.top || 0,
        left: position?.left || 0,
        zIndex: 9999,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        padding: 0,
        minWidth: '200px',
      }}
    >
      <table className="table table-sm table-bordered mb-0" style={{ margin: 0 }}>
        <tbody>
          <tr>
            <td className="fw-semibold bg-light" style={{ padding: '6px 10px' }}>
              Дата рождения
            </td>
            <td style={{ padding: '6px 10px' }}>{format_date(data.birth_date) || '-'}</td>
          </tr>
          <tr>
            <td className="fw-semibold bg-light" style={{ padding: '6px 10px' }}>
              Паспорт
            </td>
            <td style={{ padding: '6px 10px' }}>
              {(() => {
                if (data.passport == null || data.passport === '') return '-'
                const d = String(data.passport).replace(/\D/g, '')
                if (d.length !== 10) return String(data.passport)
                return `${d.slice(0, 4)} ${d.slice(4)}`
              })()}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default AccessObjectTooltip
